var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapSolidPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72253 2.67727C5.85707 2.60388 6.00003 2.71678 6.00003 2.87003V13.0197C6.00003 13.1973 5.87845 13.3472 5.72253 13.4323V13.4323L3.96003 14.4373C2.73003 15.1423 1.71753 14.5573 1.71753 13.1323V5.83477C1.71753 5.36227 2.05503 4.77727 2.47503 4.53727L5.72253 2.67727V2.67727Z",
    fill: "#2C3891"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9719 4.54225C11.1422 4.62661 11.25 4.80024 11.25 4.99032V14.5786C11.25 14.9471 10.865 15.189 10.533 15.0291L7.59548 13.6138C7.42248 13.5305 7.3125 13.3554 7.3125 13.1634V3.53556C7.3125 3.1647 7.70206 2.92291 8.0344 3.08749L10.9719 4.54225Z",
    fill: "#2C3891"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.86755V12.165C16.5 12.6375 16.1625 13.2225 15.7425 13.4625L13.3111 14.856C12.9778 15.047 12.5625 14.8064 12.5625 14.4222V4.82037C12.5625 4.64086 12.6587 4.47512 12.8146 4.38613L14.2575 3.56255C15.4875 2.85755 16.5 3.44255 16.5 4.86755Z",
    fill: "#2C3891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSolidPrimary);
export default __webpack_public_path__ + "static/media/map-solid-primary.f1dc6e4f3924b65a93ff8589477579df.svg";
export { ForwardRef as ReactComponent };